// Messages that come back from the API (shown in toasts and forms).
export default {
  "A closed booking cannot be reopened. Create a new booking.": "لا يمكن إعادة فتح حجز مغلق. أنشئ حجزًا جديدًا.",
  "API rate limit exceeded. Free tier allows 100 searches per day.": "تم تجاوز حد الاستخدام. الخطة المجانية تسمح بـ 100 عملية بحث يوميًا.",
  "Access denied: Category belongs to different branch": "تم رفض الوصول: التصنيف يتبع فرعًا آخر",
  "Access denied: Item belongs to different branch": "تم رفض الوصول: العنصر يتبع فرعًا آخر",
  "Access denied: Stock item belongs to different branch": "تم رفض الوصول: عنصر المخزون يتبع فرعًا آخر",
  "Access denied: Table belongs to different branch": "تم رفض الوصول: الطاولة تتبع فرعًا آخر",
  "Access token required": "يلزم تسجيل الدخول",
  "Adjustment would take balance negative": "هذا التعديل سيجعل الرصيد سالبًا",
  "Admin username already exists": "اسم المستخدم للمدير موجود بالفعل",
  "Admin username, password, and full name are required": "اسم المستخدم وكلمة المرور والاسم الكامل للمدير مطلوبة",
  "Alert resolved successfully": "تم حل التنبيه بنجاح",
  "All variants deleted successfully": "تم حذف جميع الخيارات بنجاح",
  "An account with this phone number already exists": "يوجد حساب بهذا الرقم بالفعل",
  "An add-on is not available for this item": "إحدى الإضافات غير متاحة لهذا العنصر",
  "An image file is required": "ملف الصورة مطلوب",
  "Assign a plan to this restaurant first": "عيّن خطة لهذا المطعم أولًا",
  "At least one image is required": "صورة واحدة على الأقل مطلوبة",
  "Authentication failed": "فشل التحقق من الهوية",
  "Authentication required": "يلزم تسجيل الدخول",
  "Backup created successfully": "تم إنشاء النسخة الاحتياطية بنجاح",
  "Backup deleted successfully": "تم حذف النسخة الاحتياطية بنجاح",
  "Backup file not found": "ملف النسخة الاحتياطية غير موجود",
  "Backup restored successfully": "تمت استعادة النسخة الاحتياطية بنجاح",
  "Booking not found": "الحجز غير موجود",
  "Both Stripe keys must be from the same mode (both test or both live)": "يجب أن يكون مفتاحا Stripe من الوضع نفسه (كلاهما للاختبار أو كلاهما مباشر)",
  "Business not found": "النشاط غير موجود",
  "Campaign cancelled": "تم إلغاء الحملة",
  "Campaign not found": "الحملة غير موجودة",
  "Cannot delete category with existing menu items": "لا يمكن حذف تصنيف يحتوي على عناصر",
  "Cannot delete menu item with existing orders": "لا يمكن حذف عنصر مرتبط بطلبات",
  "Cannot delete menu item. It is referenced in other records. Please remove all associations first.": "لا يمكن حذف العنصر لأنه مرتبط بسجلات أخرى. يرجى إزالة الارتباطات أولًا.",
  "Cannot delete stock item used in recipes": "لا يمكن حذف عنصر مخزون مستخدم في وصفات",
  "Cannot delete table with active orders": "لا يمكن حذف طاولة عليها طلبات نشطة",
  "Cannot delete your own account": "لا يمكنك حذف حسابك",
  "Cannot read this sheet. Use a sheet already shared for link viewing, or download it as Excel / CSV and upload that file.": "تعذرت قراءة هذا الجدول. استخدم جدولًا مشاركًا للعرض بالرابط، أو نزّله كملف Excel / CSV وارفعه.",
  "Card payments are not available for this store": "الدفع بالبطاقة غير متاح لهذا المتجر",
  "Category not found": "التصنيف غير موجود",
  "Change and reason are required": "التغيير والسبب مطلوبان",
  "Choose a future time and provide your name and phone": "اختر وقتًا قادمًا وأدخل اسمك ورقم هاتفك",
  "Choose a party size from 1 to 30": "اختر عدد أشخاص من 1 إلى 30",
  "Choose a photo or PDF of your transfer receipt": "اختر صورة أو ملف PDF لإيصال التحويل",
  "Choose a valid date": "اختر تاريخًا صحيحًا",
  "Choose a valid fulfillment method and delivery address": "اختر طريقة استلام صحيحة وعنوان توصيل",
  "Choose approve or reject": "اختر الموافقة أو الرفض",
  "Choose one of the available plans": "اختر إحدى الخطط المتاحة",
  "Choose a supported currency": "اختر عملة مدعومة",
  "Choose a valid template": "اختر قالبًا صالحًا",
  "Choose English, Arabic or both": "اختر الإنجليزية أو العربية أو كلتيهما",
  "Connect WhatsApp before sending a campaign": "اربط واتساب قبل إرسال الحملة",
  "Could not activate theme": "تعذر تفعيل الثيم",
  "Could not check the card payment right now": "تعذر التحقق من الدفع بالبطاقة حاليًا",
  "Could not determine which restaurant this order is for": "تعذر تحديد المطعم الخاص بهذا الطلب",
  "Could not start the card payment. Please try again.": "تعذر بدء الدفع بالبطاقة. حاول مرة أخرى.",
  "Could not create reservation": "تعذر إنشاء الحجز",
  "Could not load reservation times": "تعذر تحميل أوقات الحجز",
  "Could not load the calendar": "تعذر تحميل التقويم",
  "Current and new passwords are required": "كلمة المرور الحالية والجديدة مطلوبتان",
  "Current password is incorrect": "كلمة المرور الحالية غير صحيحة",
  "Customer already exists": "العميل موجود بالفعل",
  "Customer no longer has enough points for this reward": "لم يعد لدى العميل نقاط كافية لهذه المكافأة",
  "Customer not found": "العميل غير موجود",
  "Duration must be between 1 and 1440 minutes": "يجب أن تكون المدة بين 1 و1440 دقيقة",
  "Each day needs valid opening and closing times, with closing after opening": "يحتاج كل يوم إلى وقتي فتح وإغلاق صحيحين، ويكون الإغلاق بعد الفتح",
  "Employee activated successfully": "تم تفعيل الموظف بنجاح",
  "Employee deactivated successfully": "تم إلغاء تفعيل الموظف بنجاح",
  "Employee not found": "الموظف غير موجود",
  "Enter a valid Google Sheets link.": "أدخل رابط Google Sheets صحيحًا.",
  "Enter a valid email address": "أدخل بريدًا إلكترونيًا صحيحًا",
  "Enter the WhatsApp number with country code, e.g. +212 600 000 000": "أدخل رقم واتساب مع رمز الدولة، مثال: ‎+212 600 000 000",
  "Exchange rate unavailable": "سعر الصرف غير متاح",
  "Failed to activate employee": "تعذر تفعيل الموظف",
  "Failed to activate restaurant": "تعذر تفعيل المطعم",
  "Failed to add images": "تعذرت إضافة الصور",
  "Failed to cancel order": "تعذر إلغاء الطلب",
  "Failed to change password": "تعذر تغيير كلمة المرور",
  "Failed to confirm order": "تعذر تأكيد الطلب",
  "Failed to create campaign": "تعذر إنشاء الحملة",
  "Failed to create category": "تعذر إنشاء التصنيف",
  "Failed to create employee": "تعذر إنشاء الموظف",
  "Failed to create menu item": "تعذر إنشاء العنصر",
  "Failed to create order": "تعذر إنشاء الطلب",
  "Failed to create recipe": "تعذر إنشاء الوصفة",
  "Failed to create restaurant": "تعذر إنشاء المطعم",
  "Failed to create service": "تعذر إنشاء الخدمة",
  "Failed to create stock item": "تعذر إنشاء عنصر المخزون",
  "Failed to create table": "تعذر إنشاء الطاولة",
  "Failed to create variant": "تعذر إنشاء الخيار",
  "Failed to create variants": "تعذر إنشاء الخيارات",
  "Failed to deactivate restaurant": "تعذر إلغاء تفعيل المطعم",
  "Failed to delete image": "تعذر حذف الصورة",
  "Failed to delete variant": "تعذر حذف الخيار",
  "Failed to delete variants": "تعذر حذف الخيارات",
  "Failed to disconnect WhatsApp": "تعذر قطع اتصال واتساب",
  "Failed to export database": "تعذر تصدير قاعدة البيانات",
  "Failed to fetch analytics": "تعذر تحميل التحليلات",
  "Failed to fetch availability": "تعذر تحميل التوفر",
  "Failed to fetch bookings": "تعذر تحميل الحجوزات",
  "Failed to fetch categories": "تعذر تحميل التصنيفات",
  "Failed to fetch dashboard stats": "تعذر تحميل إحصاءات لوحة التحكم",
  "Failed to fetch employee": "تعذر تحميل الموظف",
  "Failed to fetch employees": "تعذر تحميل الموظفين",
  "Failed to fetch inventory history": "تعذر تحميل سجل المخزون",
  "Failed to fetch logs": "تعذر تحميل السجلات",
  "Failed to fetch low stock alerts": "تعذر تحميل تنبيهات المخزون",
  "Failed to fetch menu": "تعذر تحميل القائمة",
  "Failed to fetch menu items": "تعذر تحميل عناصر القائمة",
  "Failed to fetch order": "تعذر تحميل الطلب",
  "Failed to fetch orders": "تعذر تحميل الطلبات",
  "Failed to fetch payments": "تعذر تحميل المدفوعات",
  "Failed to fetch product": "تعذر تحميل المنتج",
  "Failed to fetch profile": "تعذر تحميل الملف الشخصي",
  "Failed to fetch recipes": "تعذر تحميل الوصفات",
  "Failed to fetch restaurant": "تعذر تحميل المطعم",
  "Failed to fetch restaurants": "تعذر تحميل المطاعم",
  "Failed to fetch services": "تعذر تحميل الخدمات",
  "Failed to fetch settings": "تعذر تحميل الإعدادات",
  "Failed to fetch stock items": "تعذر تحميل عناصر المخزون",
  "Failed to fetch stock movements": "تعذر تحميل حركات المخزون",
  "Failed to fetch table": "تعذر تحميل الطاولة",
  "Failed to fetch tables": "تعذر تحميل الطاولات",
  "Failed to generate QR sheet": "تعذر إنشاء صفحة رموز QR",
  "Failed to generate unique PIN": "تعذر إنشاء رمز PIN فريد",
  "Failed to list backups": "تعذر عرض النسخ الاحتياطية",
  "Failed to process refund": "تعذرت معالجة الاسترداد",
  "Failed to record payment": "تعذر تسجيل الدفع",
  "Failed to reset settings": "تعذرت إعادة تعيين الإعدادات",
  "Failed to save payment settings": "تعذر حفظ إعدادات الدفع",
  "Failed to start WhatsApp connection": "تعذر بدء الاتصال بواتساب",
  "Failed to toggle menu item availability": "تعذر تغيير توفر العنصر",
  "Failed to update business hours": "تعذر تحديث ساعات العمل",
  "Failed to update category": "تعذر تحديث التصنيف",
  "Failed to update employee": "تعذر تحديث الموظف",
  "Failed to update menu item": "تعذر تحديث العنصر",
  "Failed to update recipe": "تعذر تحديث الوصفة",
  "Failed to update restaurant": "تعذر تحديث المطعم",
  "Failed to update service": "تعذر تحديث الخدمة",
  "Failed to update settings": "تعذر تحديث الإعدادات",
  "Failed to update stock item": "تعذر تحديث عنصر المخزون",
  "Failed to update table": "تعذر تحديث الطاولة",
  "Failed to update the payment": "تعذر تحديث الدفع",
  "Failed to update variant": "تعذر تحديث الخيار",
  "Failed to upload images": "تعذر رفع الصور",
  "Failed to upload the receipt": "تعذر رفع الإيصال",
  "Failed to add image": "تعذرت إضافة الصورة",
  "Failed to load settings": "تعذر تحميل الإعدادات",
  "Failed to save setting": "تعذر حفظ الإعداد",
  "File too large. Maximum size is 5MB.": "الملف كبير جدًا. الحد الأقصى 5 ميغابايت.",
  "Fix the invalid rows before importing. Nothing was saved.": "صحّح الصفوف غير الصالحة قبل الاستيراد. لم يتم حفظ أي شيء.",
  "For bank transfers, enter the account holder name and an account number or IBAN": "للتحويل البنكي، أدخل اسم صاحب الحساب ورقم الحساب أو IBAN",
  "Full name, username, password, and store name are required": "الاسم الكامل واسم المستخدم وكلمة المرور واسم المتجر مطلوبة",
  "Image deleted successfully": "تم حذف الصورة بنجاح",
  "Image not found": "الصورة غير موجودة",
  "Import between 1 and 1,000 rows at a time.": "استورد ما بين 1 و1,000 صف في كل مرة.",
  "Imports are available for restaurant and ecommerce accounts.": "الاستيراد متاح لحسابات المطاعم والمتاجر الإلكترونية.",
  "Insufficient permissions": "صلاحيات غير كافية",
  "Internal server error": "خطأ في الخادم",
  "Invalid PIN format": "صيغة PIN غير صحيحة",
  "Invalid PIN or authentication required": "رمز PIN غير صحيح أو يلزم تسجيل الدخول",
  "Invalid business type": "نوع نشاط غير صالح",
  "Invalid or expired token": "انتهت صلاحية الجلسة، يرجى تسجيل الدخول مجددًا",
  "Invalid or inactive user": "مستخدم غير صالح أو غير نشط",
  "Invalid order PIN": "رمز PIN للطلب غير صحيح",
  "Invalid payment status": "حالة دفع غير صالحة",
  "Invalid phone number or password": "رقم الهاتف أو كلمة المرور غير صحيحة",
  "Invalid refresh token": "جلسة غير صالحة",
  "Invalid report type": "نوع تقرير غير صالح",
  "Invalid sheet tab.": "ورقة غير صالحة.",
  "Invalid social links": "روابط تواصل اجتماعي غير صالحة",
  "Invalid start time": "وقت بدء غير صالح",
  "Invalid status": "حالة غير صالحة",
  "Invalid token": "جلسة غير صالحة",
  "Invalid reservations setting": "إعداد الحجوزات غير صالح",
  "Invalid low stock alert setting": "إعداد تنبيه المخزون غير صالح",
  "Item not found": "العنصر غير موجود",
  "Keep at least one payment method turned on": "أبقِ طريقة دفع واحدة على الأقل مفعّلة",
  "Live exchange rate is unavailable right now": "سعر الصرف المباشر غير متاح حاليًا",
  "Login required": "يلزم تسجيل الدخول",
  "Logout failed": "فشل تسجيل الخروج",
  "Low stock alert must be a whole number (0 or more)": "يجب أن يكون تنبيه المخزون رقمًا صحيحًا (0 أو أكثر)",
  "Menu item not found": "العنصر غير موجود",
  "Message text is required": "نص الرسالة مطلوب",
  "Missing required fields": "حقول مطلوبة ناقصة",
  "Name and code are required": "الاسم والرمز مطلوبان",
  "Name is required": "الاسم مطلوب",
  "Name, price, and category are required": "الاسم والسعر والتصنيف مطلوبة",
  "New password must be at least 6 characters": "يجب ألا تقل كلمة المرور الجديدة عن 6 أحرف",
  "No customers have opted into marketing messages yet": "لم يوافق أي عميل على الرسائل التسويقية بعد",
  "No image file provided": "لم يتم تقديم ملف صورة",
  "No image files provided": "لم يتم تقديم ملفات صور",
  "No receipt uploaded": "لم يتم رفع إيصال",
  "No receipt uploaded for this order": "لم يتم رفع إيصال لهذا الطلب",
  "No store associated with this account": "لا يوجد متجر مرتبط بهذا الحساب",
  "No store is assigned to this account": "لا يوجد متجر معيّن لهذا الحساب",
  "Not enough points for this reward": "لا توجد نقاط كافية لهذه المكافأة",
  "Only an in-progress campaign can be cancelled": "يمكن إلغاء الحملة الجارية فقط",
  "Only image files are allowed!": "يُسمح بملفات الصور فقط!",
  "Order cancelled successfully": "تم إلغاء الطلب بنجاح",
  "Order cannot be cancelled in current status": "لا يمكن إلغاء الطلب في حالته الحالية",
  "Order cannot be confirmed in current status": "لا يمكن تأكيد الطلب في حالته الحالية",
  "Order confirmed successfully": "تم تأكيد الطلب بنجاح",
  "Order created successfully": "تم إنشاء الطلب بنجاح",
  "Order is already fully paid": "الطلب مدفوع بالكامل بالفعل",
  "Order not found with this PIN": "لا يوجد طلب بهذا الرمز",
  "PIN already in use": "رمز PIN مستخدم بالفعل",
  "PIN login failed": "فشل تسجيل الدخول برمز PIN",
  "Password must be at least 6 characters": "يجب ألا تقل كلمة المرور عن 6 أحرف",
  "Payment failed": "فشل الدفع",
  "Payment not found": "الدفع غير موجود",
  "Payment processed successfully": "تمت معالجة الدفع بنجاح",
  "Payment processing failed": "فشلت معالجة الدفع",
  "Payment recorded successfully": "تم تسجيل الدفع بنجاح",
  "Phone and a password of at least 6 characters are required": "الهاتف وكلمة مرور من 6 أحرف على الأقل مطلوبان",
  "Phone and password are required": "الهاتف وكلمة المرور مطلوبان",
  "Printer configuration updated successfully": "تم تحديث إعدادات الطابعة بنجاح",
  "Product not found": "المنتج غير موجود",
  "Provide a valid price and duration": "أدخل سعرًا ومدة صحيحين",
  "Receipt file is missing": "ملف الإيصال مفقود",
  "Recipe already exists for this menu item and stock item": "الوصفة موجودة بالفعل لهذا العنصر وعنصر المخزون",
  "Recipe deleted successfully": "تم حذف الوصفة بنجاح",
  "Refund processed successfully": "تمت معالجة الاسترداد بنجاح",
  "Registration failed": "فشل التسجيل",
  "Reservation not found": "الحجز غير موجود",
  "Restaurant activated successfully": "تم تفعيل المطعم بنجاح",
  "Restaurant code already exists": "رمز المطعم موجود بالفعل",
  "Restaurant deactivated successfully": "تم إلغاء تفعيل المطعم بنجاح",
  "Restaurant not found": "المطعم غير موجود",
  "Reward deleted": "تم حذف المكافأة",
  "Reward is no longer available": "المكافأة لم تعد متاحة",
  "Reward not found": "المكافأة غير موجودة",
  "Reward not found or inactive": "المكافأة غير موجودة أو غير نشطة",
  "Search query is required": "كلمة البحث مطلوبة",
  "Select a business first": "اختر نشاطًا أولًا",
  "Select a restaurant staff account": "اختر حساب موظف في المطعم",
  "Select a store first": "اختر متجرًا أولًا",
  "Select a store before updating its settings": "اختر متجرًا قبل تحديث إعداداته",
  "Service duration is invalid": "مدة الخدمة غير صالحة",
  "Service not found": "الخدمة غير موجودة",
  "Service, name, phone, and start time are required": "الخدمة والاسم والهاتف ووقت البدء مطلوبة",
  "Settings reset to defaults successfully": "تمت إعادة الإعدادات إلى الافتراضي بنجاح",
  "Settings updated successfully": "تم تحديث الإعدادات بنجاح",
  "Sheet exceeds 5 MB. Export a smaller sheet.": "الجدول يتجاوز 5 ميغابايت. صدّر جدولًا أصغر.",
  "Start date and end date are required": "تاريخ البداية والنهاية مطلوبان",
  "Stock item not found": "عنصر المخزون غير موجود",
  "Stock quantity must be a whole number (0 or more)": "يجب أن تكون كمية المخزون رقمًا صحيحًا (0 أو أكثر)",
  "Store not found": "المتجر غير موجود",
  "Stripe is not configured on this server (STRIPE_SECRET_KEY missing)": "لم يتم إعداد Stripe على الخادم",
  "Stripe not configured": "لم يتم إعداد Stripe",
  "Subscription cancellation scheduled": "تمت جدولة إلغاء الاشتراك",
  "Table not found": "الطاولة غير موجودة",
  "Table number already exists in this branch": "رقم الطاولة موجود بالفعل في هذا الفرع",
  "Table number and capacity are required": "رقم الطاولة والسعة مطلوبان",
  "That date is already blocked": "هذا التاريخ محظور بالفعل",
  "That time is no longer available. Choose another time.": "هذا الوقت لم يعد متاحًا. اختر وقتًا آخر.",
  "That username is already taken": "اسم المستخدم هذا مستخدم بالفعل",
  "The Stripe publishable key should start with pk_test_ or pk_live_": "يجب أن يبدأ المفتاح العام لـ Stripe بـ pk_test_ أو pk_live_",
  "The Stripe secret key should start with sk_test_, sk_live_ or rk_": "يجب أن يبدأ المفتاح السري لـ Stripe بـ sk_test_ أو sk_live_ أو rk_",
  "The selected product option is no longer available": "خيار المنتج المحدد لم يعد متاحًا",
  "The selected template is not available for this business type": "القالب المحدد غير متاح لهذا النوع من الأنشطة",
  "Theme file must contain valid JSON": "يجب أن يحتوي ملف الثيم على JSON صالح",
  "Theme uploaded and saved. Activate it from the storefront settings.": "تم رفع الثيم وحفظه. فعّله من إعدادات واجهة المتجر.",
  "This business is not accepting requests right now": "هذا النشاط لا يستقبل طلبات حاليًا",
  "This order is already paid": "هذا الطلب مدفوع بالفعل",
  "This order is not paid by bank transfer": "هذا الطلب ليس بالتحويل البنكي",
  "This order is not paid by card": "هذا الطلب ليس بالبطاقة",
  "This order was cancelled": "تم إلغاء هذا الطلب",
  "This payment is already verified": "تم التحقق من هذا الدفع بالفعل",
  "This payment method is not available for this store. Please choose another one.": "طريقة الدفع هذه غير متاحة لهذا المتجر. يرجى اختيار طريقة أخرى.",
  "This restaurant has been suspended. Contact the platform owner to resolve this.": "تم تعليق هذا المطعم. تواصل مع مالك المنصة لحل المشكلة.",
  "This restaurant has no active subscription": "لا يوجد اشتراك نشط لهذا المطعم",
  "This restaurant has no billing account yet": "لا يوجد حساب فوترة لهذا المطعم بعد",
  "This restaurant is not currently accepting orders": "هذا المطعم لا يستقبل الطلبات حاليًا",
  "This restaurant is not taking online reservations right now": "هذا المطعم لا يستقبل الحجوزات عبر الإنترنت حاليًا",
  "This restaurant is temporarily unavailable": "هذا المطعم غير متاح مؤقتًا",
  "This status change is not allowed": "تغيير الحالة هذا غير مسموح",
  "This time is no longer available. Please choose another time.": "هذا الوقت لم يعد متاحًا. يرجى اختيار وقت آخر.",
  "To accept cards, enter both your Stripe publishable key and secret key": "لقبول البطاقات، أدخل المفتاح العام والمفتاح السري لـ Stripe",
  "Too many files. Maximum is 10 files.": "عدد الملفات كبير جدًا. الحد الأقصى 10 ملفات.",
  "Too many login attempts, please try again later.": "محاولات دخول كثيرة، حاول لاحقًا.",
  "Too many orders, please slow down.": "طلبات كثيرة، يرجى التمهل.",
  "Too many requests from this IP, please try again later.": "طلبات كثيرة، حاول لاحقًا.",
  "Unsupported currency": "عملة غير مدعومة",
  "Upload a .json or .theme file": "ارفع ملف ‎.json أو ‎.theme",
  "Upload a JPG, PNG, WEBP or PDF file": "ارفع ملف JPG أو PNG أو WEBP أو PDF",
  "Upload a theme first": "ارفع ثيمًا أولًا",
  "Upload failed": "فشل الرفع",
  "Use a valid date in YYYY-MM-DD format": "استخدم تاريخًا صحيحًا بصيغة YYYY-MM-DD",
  "Use a valid month in YYYY-MM format": "استخدم شهرًا صحيحًا بصيغة YYYY-MM",
  "Use the normal docs.google.com/spreadsheets/d/... sharing link.": "استخدم رابط المشاركة العادي docs.google.com/spreadsheets/d/...",
  "User is not assigned to a branch": "المستخدم غير معيّن لفرع",
  "Username already exists": "اسم المستخدم موجود بالفعل",
  "Username and PIN required": "اسم المستخدم ورمز PIN مطلوبان",
  "Validation failed": "فشل التحقق من البيانات",
  "Variant deleted successfully": "تم حذف الخيار بنجاح",
  "Variant not found": "الخيار غير موجود",
  "WhatsApp is not connected for this restaurant": "واتساب غير متصل لهذا المطعم",
  "You already have a subscription. Use \"Manage payment method\" to change it.": "لديك اشتراك بالفعل. استخدم \"إدارة طريقة الدفع\" لتغييره.",
  "Your name and phone are required": "اسمك ورقم هاتفك مطلوبان",
  "Could not load billing": "تعذر تحميل الفوترة",
  "Could not start checkout": "تعذر بدء الدفع",
  "Failed to open billing portal": "تعذر فتح بوابة الفوترة",
  "Failed to load product stock": "تعذر تحميل مخزون المنتجات",
  "Failed to update stock": "تعذر تحديث المخزون",
  "unavailable": "غير متاح"
}
